import type { FC } from 'react';
import React from 'react';
import { useTranslation } from '@edreamsodigeo/frontend-core';

const MINUTES_IN_A_HOUR = 60;

export const Duration: FC<{ durationInMinutes: number }> = ({
  durationInMinutes,
}) => {
  const { t } = useTranslation();

  if (!durationInMinutes) return null;

  const hours = Math.floor(durationInMinutes / MINUTES_IN_A_HOUR);
  const minutes = String(durationInMinutes % MINUTES_IN_A_HOUR).padStart(
    2,
    '0'
  );

  return <>{t('flightSummary.segment.duration', { hours, minutes })}</>;
};
